module.exports = __webpack_public_path__ + "static/img/blog_hed-1.3247b8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/blog_hed-1.jpg
// module id = +8aA
// module chunks = 0